/**
 * shareViaText — actually deliver a text-message share.
 *
 * `sms:` links only work on devices with a messaging app (phones).
 * On desktop the old code claimed "Opening your messages app…" while
 * nothing happened. Now:
 *   - mobile  → open the SMS composer (iOS uses `&body`, others `?body`)
 *   - desktop → Web Share sheet if available, else copy to clipboard
 * Returns the method used so callers can show an accurate toast.
 */
export async function shareViaText(body) {
    const ua = (typeof navigator !== "undefined" && navigator.userAgent) || "";
    const isIOS = /iPhone|iPad|iPod/i.test(ua);
    const isMobile = isIOS || /Android/i.test(ua);

    if (isMobile) {
        const sep = isIOS ? "&" : "?";
        window.location.href = `sms:${sep}body=${encodeURIComponent(body)}`;
        return "sms";
    }
    if (navigator.share) {
        try {
            await navigator.share({ text: body });
            return "share";
        } catch (e) {
            if (e && e.name === "AbortError") return "cancelled";
        }
    }
    try {
        await navigator.clipboard.writeText(body);
        return "copied";
    } catch {
        return "failed";
    }
}

/** Standard toast copy per share method. */
export function textShareToast(method, toast) {
    if (method === "sms") toast.success("Opening your messages app…");
    else if (method === "share") toast.success("Shared.");
    else if (method === "copied") toast.success("Message copied — paste it into your texting app.");
    else if (method === "failed") toast.error("Couldn't open messaging here. Try copying the text instead.");
    // "cancelled" → silent
}
